/**
 * LayoutWizardService
 * 
 * Guides the user through a set of key presses to infer the physical keyboard layout.
 */
export class LayoutWizardService extends EventTarget {
  constructor() {
    super();
    this.isActive = false;
    this.currentStep = 0;
    this.detectedLayout = 'ANSI';
    
    // Disambiguation steps
    this.STEPS = [
      { 
        id: 'iso_key', 
        instruction: 'PRESS_THE_KEY_LEFT_OF_Z_(ISO_ONLY)', 
        options: {
          'IntlBackslash': 'ISO',
          'Backslash': 'ANSI',
          'KeyZ': 'ANSI',
          'IntlRo': 'JIS'
        }
      },
      {
        id: 'jis_check',
        instruction: 'PRESS_THE_KEY_LEFT_OF_BACKSPACE_(YEN_ON_JIS)',
        options: {
          'Equal': 'ANSI/ISO',
          'IntlYen': 'JIS' // JIS has a specific Yen key here
        }
      }
    ];
  }

  start() {
    this.isActive = true;
    this.currentStep = 0;
    this.dispatchStep();
  }

  recordKey(code) {
    if (!this.isActive) return;

    const step = this.STEPS[this.currentStep];
    const layout = step.options[code];

    if (layout) {
      if (layout !== 'ANSI/ISO') {
        this.detectedLayout = layout;
      }
      
      this.currentStep++;
      if (this.currentStep >= this.STEPS.length) {
        this.complete();
      } else {
        this.dispatchStep();
      }
    }
  }

  dispatchStep() {
    this.dispatchEvent(new CustomEvent('wizardstep', {
      detail: {
        step: this.currentStep + 1,
        total: this.STEPS.length,
        instruction: this.STEPS[this.currentStep].instruction
      }
    }));
  }

  complete() {
    this.isActive = false;
    this.dispatchEvent(new CustomEvent('wizardcomplete', {
      detail: { layout: this.detectedLayout }
    }));
  }
}

export const layoutWizardService = new LayoutWizardService();
